import React from 'react';
import classNames from 'clsx';

import { PageHeaderProps } from './PageHeader.interfaces';
import { useStyles } from './PageHeader.styles';

export default function PageHeader({
  title,
  titleSuffix,
  subTitle,
  secondTitle,
  renderAddon: Addon,
  dataCy,
  newPageHeader,
  className,
}: PageHeaderProps) {
  const classes = useStyles({ newPageHeader })();

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.contentWrapper}>
        <div className={classes.heading} data-cy={dataCy}>
          <h1 className={classes.title}>
            {title}
            {titleSuffix && (
              <span className={classes.titleSuffix}>{titleSuffix}</span>
            )}
          </h1>
          {secondTitle && (
            <h2 className={classes.secondTitle}>{secondTitle}</h2>
          )}
          {subTitle && <div className={classes.subTitle}>{subTitle}</div>}
        </div>
        {Addon && (
          <div className={classes.addon}>
            <Addon />
          </div>
        )}
      </div>
    </div>
  );
}
